/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import calenderSvg from '../../../public/calender.svg';
import productsSvg from '../../../public/myproducts.svg';
import viewicoSvg from '../../../public/view-ico.svg';
import adprdc from '../../../public/adprdc.svg';
import mydetailicoSvg from '../../../public/mydetail.svg';
import editdets from '../../../public/editdets.svg';
import totaleventsicoSvg from '../../../public/totalevents.svg';
import addprdicon from '../../../public/addprdicon.svg';
import EventService from '../../../services/EventService';
import ProductService from '../../../services/ProductService';
import UserService from '../../../services/UserService';
import { showLoading } from 'react-global-loading';
import Notifications from '../../component/Notifications';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class ClinicDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventList: [],
      productsList: [],
      centerList: []
    };
  }

  componentDidMount = () => {
    this.getEventList();
    this.getProductList();
    this.getUserDetail(userData.uid);
    this.getNotifications();
  };


  getNotifications = () => {
    UserService.getNotifications()
      .then((result) => {
        if (!result) return;
        this.setState({ notiData: result.data });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  getProductList = () => {
    ProductService.fetchProductsByBlog({ 'blog_id': userData?.blog_id?.userblog_id })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ productsList: result });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getUserDetail = (id) => {
    UserService.getUsersDetail(id)
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({
          centerList: result.data.centerData,
          userData: result.data
          // username: result.data.display_name, consultingFee: result.data?.fee, practitionerEmail: result.data?.user_email, myImgApi: result.data?.user_image, selectedPractionerCountry: result.data.user_country.id, selectedPractitionerCategory: result.data.domain, centerData: result.data.centerData, certificateData: result.data.certificateData
        });

      }).catch((err) => {

        console.error(err);
      });
  };

  getEventList = () => {
    EventService.getEventListByCountry({ 'blog_id': userData?.blog_id?.userblog_id })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ eventList: result });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    const { eventList, productsList, centerList, userData } = this.state;

    return (
      <div className="container pt-2 pmloginscrn">
        {/* <nx */}
        <div className="row p-2 mt-5 mb-3 rounded rounded-2 brdr">
          <div className="col-12 event-title mb-4">
            <h4 className="fw-normal t0">Welcome, <span className="fw-bold prnmbld">
              {userData?.display_name}</span></h4>
          </div>
          <div className="cardsrwo">
            <div className="pracdashcardcont">
              <div className="card card-ico">
                <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className=" fw-bold crnm t1">My Products</h5>
                  <img src={productsSvg} className="float-end" alt="my events" />
                  </div>
                  
                  <div className="d-flex justify-content-center align-items-baseline my-3 badge rounded t2 rounded-3 text-bg-light w-100 align-middle p-2 countsct">
                    <span className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{productsList.length}</span>
                    <small className="text-primary-emphasis fst-italic">Total Products Added</small>
                  </div>
                  
                  <div className="row my-2">
                    <div className="col-auto">
                      <Link to='/view-practitioner-products' className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                         View / Edit Products
                      </Link>
                    </div>
                    <div className="col-auto">
                      <Link to='/add-practitioner-products' className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                        Add product
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pracdashcardcont">
              <div className="card card-ico">
                <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className=" fw-bold crnm t1">My Details</h5>
                  <img src={mydetailicoSvg} className="float-end" alt="my events" />
                  </div>
                  
                  <div className="d-flex justify-content-center align-items-baseline my-3 badge rounded t2 rounded-3 text-bg-light w-100 align-middle p-2 countsct">
                    <span className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{centerList.length}</span>
                    <small className="text-primary-emphasis fst-italic">Total Centers</small>
                  </div>                 
                  <div className="row my-2">
                    <div className="col-12">
                      <Link to={{ pathname: "/view-practice-data", state: { userData, type: 'view' } }} className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">                       
                        View / Edit Details
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pracdashcardcont">
              <div className="card card-ico">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                  <h5 className=" fw-bold crnm t1">My Events</h5>
                  <img src={totaleventsicoSvg} className="float-end" alt="my events" />
                  </div>
                  
                  <div className="d-flex justify-content-center align-items-baseline my-3 badge rounded t2 rounded-3 text-bg-light w-100 align-middle p-2 countsct">
                    <span className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{eventList.length}</span>
                    <small className="text-primary-emphasis fst-italic">Total Events</small>
                  </div>
                 
                  <div className="row my-2">
                    <div className="col-auto">
                      <Link to='/view-practitioner-events' className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                      View / Edit  Events</Link>
                    </div>
                    <div className="col-auto">
                      <Link to='/add-practitioner-events' className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                       Add Event</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Notifications />
        {/* <div className="row p-2 mt-5 mb-3 rounded rounded-2 m-ver-col">
          <div className="col-12">
            <ul className="nav nav-tabs alleventtabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active t1" id="notifications-tab" data-bs-toggle="tab" data-bs-target="#notifications-pane" type="button" role="tab" aria-controls="notifications-pane" aria-selected="true">Notifications</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link t1" id="events-around-me-tab" data-bs-toggle="tab" data-bs-target="#events-around-me-pane" type="button" role="tab" aria-controls="events-around-me-pane" aria-selected="false">Events Around Me <span className="badge text-bg-secondary rounded-circle p-2">30</span></button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="notifications-pane" >
                <div className="row mt-4">
                  <div className="col-12 mb-4">
                    <div className="fw-normal show-count t2">Important and General Notifications regarding your practitioner account from Ministry of Ayush</div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-3 bggrr border-0 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">A</span>
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">Certification Document Approved</h5>
                            <p className="card-text mb-1">
                              <small className="text-dark t4">23th October 2024</small>
                            </p>
                            <p className="card-text t2">Supporting line text lorem ipsum dolor sit amet, consectetur</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-3 bggrr border-0 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">A</span>
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">Certification Document Approved</h5>
                            <p className="card-text mb-1">
                              <small className="text-dark t4">23th October 2024</small>
                            </p>
                            <p className="card-text t2">Supporting line text lorem ipsum dolor sit amet, consectetur</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-3 bggrr border-0 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">A</span>
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">Certification Document Approved</h5>
                            <p className="card-text mb-1">
                              <small className="text-dark t4">23th October 2024</small>
                            </p>
                            <p className="card-text t2">Supporting line text lorem ipsum dolor sit amet, consectetur</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-3 bggrr border-0 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">A</span>
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">Certification Document Approved</h5>
                            <p className="card-text mb-1">
                              <small className="text-dark t4">23th October 2024</small>
                            </p>
                            <p className="card-text t2">Supporting line text lorem ipsum dolor sit amet, consectetur</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-3 bggrr border-0 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">A</span>
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">Certification Document Approved</h5>
                            <p className="card-text mb-1">
                              <small className="text-dark t4">23th October 2024</small>
                            </p>
                            <p className="card-text t2">Supporting line text lorem ipsum dolor sit amet, consectetur</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-3 bggrr border-0 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">A</span>
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0 t1">Certification Document Approved</h5>
                            <p className="card-text mb-1">
                              <small className="text-dark t4">23th October 2024</small>
                            </p>
                            <p className="card-text t2">Supporting line text lorem ipsum dolor sit amet, consectetur</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="events-around-me-pane" aria-labelledby="events-around-me" >
                <div className="row mt-4">
                  <div className="col-12 mb-4">
                    <div className="fw-normal show-count">Showing 8 of 10 results...</div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card p-2 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1 ancmtimg">
                          <img src={calenderSvg} className="mt-3" alt="awaiting events" />
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Event Name
                              <span className="badge text-bg-secondary float-end fw-normal p-3 rounded rounded-5 countproduct">15 Registrations</span></h5>
                            <span className="theme-font-color fw-bold d-block mb-2"><i className="fa fa-user-md" aria-hidden="true"></i> Dr Vivek’s Naturopathy</span>
                            <p className="card-text">Supporting line about the event lorem imsum dolor sit amet tempor lorem ipsum dolor sit amet.</p>
                            <p className="card-text">
                              <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney | <b>24th October 2022</b></small>
                              <Link to='/' className="card-link mx-4 fw-bold mrlr0">View/ Edit Details</Link></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card p-2 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <img src={calenderSvg} className="mt-3" alt="awaiting events" />
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Event Name
                              <span className="badge text-bg-secondary float-end fw-normal p-3 rounded rounded-5 countproduct">15 Registrations</span></h5>
                            <span className="theme-font-color fw-bold d-block mb-2"><i className="fa fa-user-md" aria-hidden="true"></i> Dr Vivek’s Naturopathy</span>
                            <p className="card-text">Supporting line about the event lorem imsum dolor sit amet tempor lorem ipsum dolor sit amet.</p>
                            <p className="card-text">
                              <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney | <b>24th October 2022</b></small>
                              <Link to='/' className="card-link mx-4 fw-bold mrlr0">View/ Edit Details</Link></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card p-2 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <img src={calenderSvg} className="mt-3" alt="awaiting events" />
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Event Name
                              <span className="badge text-bg-secondary float-end fw-normal p-3 rounded rounded-5 countproduct">15 Registrations</span></h5>
                            <span className="theme-font-color fw-bold d-block mb-2"><i className="fa fa-user-md" aria-hidden="true"></i> Dr Vivek’s Naturopathy</span>
                            <p className="card-text">Supporting line about the event lorem imsum dolor sit amet tempor lorem ipsum dolor sit amet.</p>
                            <p className="card-text">
                              <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney | <b>24th October 2022</b></small>
                              <Link to='/' className="card-link mx-4 fw-bold mrlr0">View/ Edit Details</Link></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card p-2 rounded rounded-4 mevecard">
                      <div className="row">
                        <div className="col-1">
                          <img src={calenderSvg} className="mt-3" alt="awaiting events" />
                        </div>
                        <div className="col-10 ps-4">
                          <div className="card-body">
                            <h5 className="card-title fs-5 fw-bold">Event Name
                              <span className="badge text-bg-secondary float-end fw-normal p-3 rounded rounded-5 countproduct">15 Registrations</span></h5>
                            <span className="theme-font-color fw-bold d-block mb-2"><i className="fa fa-user-md" aria-hidden="true"></i> Dr Vivek’s Naturopathy</span>
                            <p className="card-text">Supporting line about the event lorem imsum dolor sit amet tempor lorem ipsum dolor sit amet.</p>
                            <p className="card-text">
                              <small className="text-muted"><i className="fa fa-map-marker" aria-hidden="true" /> Sydney | <b>24th October 2022</b></small>
                              <Link to='/' className="card-link mx-4 fw-bold mrlr0">View/ Edit Details</Link></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}
export default ClinicDashboard;